import styled, { css } from 'styled-components';
import { COLORS, MQS, SHADOWS, FONT_FAMILY } from '../../app/common/constants/styles';

export const mainTileStyles = css`
    padding: 40px 0 40px 40px;
    display: flex;
    border-radius: 4px;
    box-shadow: ${SHADOWS.level1};
    margin-bottom: 40px;
    padding-bottom: 20px;
`;

export const ServiceLogo = styled.div`
    margin-bottom: 10px;
`;

export const BottomEUService = styled.div`
    margin-top: 50px;
    margin-bottom: 40px;
`;

export const BottomEUServiceTitle = styled.p`
    font-size: 1.5rem;
    line-height: 1.5;
`;

export const BottomEUServiceLogo = styled.span`
    margin-left: 20px;
    margin-right: 40px;
`;

export const ImgLogo = styled.img`
    height: 2rem;
`;

export const IntroText = styled.div`
    font-size: 0.875rem;
    padding-bottom: 10px;
    margin-bottom: 15px;
    margin-right: 30px;
    border-bottom: 1px solid ${COLORS.lightGrey};
    line-height: 1.5rem;
`;

export const ServiceInfo = styled.div`
    width: 100%;
`;

export const OptionalCheckbox = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 20px;
    position: relative;
    min-height: 35px;

    & p {
        font-size: 0.875rem;
        color: ${COLORS.grey7};
        max-width: 70%;
        @media (min-width: ${MQS.mq3Min}) {
            padding-right: 50px;
        }
    }
`;
export const Wrapper = styled.div`
    position: relative;
`;
export const Loading = styled.div`
    z-index: 10;
    width: 100%;
    height: 100vh;

    display: flex;
    position: absolute;

    align-items: center;
    justify-content: center;
`;

export const AgreementLink = styled.a`
    color: ${COLORS.rakutenRed};
    display: block;
    font-size: 0.875rem;
    line-height: 1.5;
    cursor: pointer;
    transition: font-weight 200ms ease-in;
    text-decoration: none;
    &:hover {
        font-weight: bold;
    }
`;

export const Bottom = styled.div``;
export const TopDescription = styled.div`
    margin-top: 30px;
    margin-bottom: 40px;
`;
export const BottomUCRMTitle = styled.p`
    text-align: left;
    ${FONT_FAMILY.multipleSemiBoldCss};
    font-weight: 500;
    font-size: 1.5rem;
    width: 100%;
    & > * {
        ${FONT_FAMILY.multipleSemiBoldCss};
    }
`;

export const BottomUCRMDescription = styled.div`
    text-align: justify;
    font-size: 0.875rem;
    width: 100%;
`;

export const DeleteLinkWrapper = styled.div`
    text-align: right;
    margin-bottom: 30px;
`;
export const DeleteLink = styled.a`
    font-size: 0.9375rem;
    color: ${COLORS.grey7};
    text-decoration: none;
    display: inline-flex;
    align-items: flex-end;
    justify-content: center;

    &:hover {
        color: ${COLORS.rakutenRed};
    }
`;

export const Separator = styled.hr`
    border: 0;
    border-bottom: solid 1px ${COLORS.grey4};
    margin: 20px 0 30px;
    width: 100%;
`;

export const ContactUsText = styled.p`
    display: inline;
    line-height: 1.5;
    color: ${COLORS.grey7};
`;

export const ContactUsLink = styled.a`
    color: ${COLORS.dark};
    cursor: pointer;
    transition: font-weight 200ms ease-in;
    text-decoration: underline;
    &:hover {
        font-weight: bold;
    }
`;

export const DataSharingPageLink = styled.a`
    color: ${COLORS.rakutenRed};
    cursor: pointer;
    transition: font-weight 200ms ease-in;
    text-decoration: none;
    &:hover {
        font-weight: bold;
    }
`;
